import styled from 'styled-components';

export const AISpecificationStyles = styled.section``;
